module.exports = __webpack_public_path__ + "img/ausstellung9.90e7198b.jpg";